// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arrokuda: PokeData = {
  "id": 846,
  "name": "arrokuda",
  "height": 5,
  "weight": 10,
  "base_experience": 56,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "fury-attack",
    "double-edge",
    "bite",
    "peck",
    "agility",
    "focus-energy",
    "crunch",
    "dive",
    "aqua-jet",
    "laser-focus",
    "liquidation"
  ],
  "moves": [
    "bite",
    "peck",
    "crunch",
    "aqua-jet",
    "liquidation",
    "rain-dance",
    "aqua-tail",
    "water-spout",
    "hydro-pump",
    "life-dew",
    "aqua-cutter",
    "bubble-beam",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 445,
    "item": null,
    "species": [
      {
        "name": "arrokuda",
        "order": 846,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "barraskewda",
        "order": 847,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 846,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 38,
    "speed": 66,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
